import request from '@/utils/request'

export function getRegisterCaptcha (params) {
  return request({
    url: '/poker/api/captcha.php',
    method: 'get',
    params
  })
}

export function sendRegister (params) {
  return request({
    url: '/poker/api/register.php',
    method: 'post',
    params
  })
}

export function getClubInfoByInvitaionCode (params) {
  return request({
    url: '/poker-api/getClubInfoByInvitaionCode',
    method: 'get',
    params
  })
}
export function checkIpLegal (params) {
  return request({
    url: `/poker-api/checkIpLegal`,
    method: 'get',
    params
  })
}

export function checkFingerprint (params) {
  return request({
    url: '/poker-api/checkFingerprintId',
    method: 'get',
    params
  })
}

// 获取 MitID 认证链接
export function getMitIDLink (params) {
  return request({
    url: '/monitor_verify_kyc/safecomply/get_mitid_verify_url?type=6',
    method: 'get',
    params
  })
}

// mit 认证结束后，将回调数据通知 server
export function reportMitCallbackData (params) {
  return request({
    url: '/monitor_verify_kyc/safecomply/elogin_callback_endpoint',
    method: 'get',
    params
  })
}
